import { Button } from "@/shared/ui/form";
import { Modal } from "@/shared/ui/overlay/Modal";

export type CloseReason = "dismissed" | "pressed-cancel" | "pressed-confirm";

export type ConfirmDialogProps = {
  isOpen: boolean;
  onClose: (reason: CloseReason) => void;
  onConfirm?: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: "default" | "destructive";
};

/**
 * 確認ダイアログコンポーネント
 * アクション実行前にユーザーに確認を求めるモーダル
 */
export const ConfirmDialog: React.FunctionComponent<ConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "実行",
  cancelText = "キャンセル",
  variant = "default",
}: ConfirmDialogProps) => {
  const handleConfirm = (): void => {
    onConfirm?.();
    onClose("pressed-confirm");
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={(): void => onClose("dismissed")}
      title={title}
      position="center"
    >
      <p className="px-4 pt-4 text-foreground whitespace-pre-line">{message}</p>
      <fieldset
        aria-label="確認操作"
        className="m-0 mt-4 flex min-w-0 gap-3 border-0 px-4 pb-4 pt-0"
      >
        <Button
          variant="default"
          className="flex-1"
          onClick={(): void => onClose("pressed-cancel")}
        >
          {cancelText}
        </Button>
        <Button variant={variant} className="flex-1" onClick={handleConfirm}>
          {confirmText}
        </Button>
      </fieldset>
    </Modal>
  );
};
